"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompetitionEntryControllerApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var CompetitionEntryControllerApi = /** @class */ (function (_super) {
    __extends(CompetitionEntryControllerApi, _super);
    function CompetitionEntryControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     */
    CompetitionEntryControllerApi.prototype.batchUpdateCompetitionEntriesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['competitionId'] == null) {
                            throw new runtime.RequiredError('competitionId', 'Required parameter "competitionId" was null or undefined when calling batchUpdateCompetitionEntries().');
                        }
                        if (requestParameters['competitionEntryBatchUpdateCommand'] == null) {
                            throw new runtime.RequiredError('competitionEntryBatchUpdateCommand', 'Required parameter "competitionEntryBatchUpdateCommand" was null or undefined when calling batchUpdateCompetitionEntries().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/{competitionId}/entries".replace("{".concat("competitionId", "}"), encodeURIComponent(String(requestParameters['competitionId']))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CompetitionEntryBatchUpdateCommandToJSON)(requestParameters['competitionEntryBatchUpdateCommand']),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentResourceCompetitionEntryResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.batchUpdateCompetitionEntries = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.batchUpdateCompetitionEntriesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.copyCompetitionEntryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling copyCompetitionEntry().');
                        }
                        if (requestParameters['competitionEntryCopyCommand'] == null) {
                            throw new runtime.RequiredError('competitionEntryCopyCommand', 'Required parameter "competitionEntryCopyCommand" was null or undefined when calling copyCompetitionEntry().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/entry/{id}/copy".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CompetitionEntryCopyCommandToJSON)(requestParameters['competitionEntryCopyCommand']),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CompetitionEntryResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.copyCompetitionEntry = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.copyCompetitionEntryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.createCompetitionEntryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['competitionId'] == null) {
                            throw new runtime.RequiredError('competitionId', 'Required parameter "competitionId" was null or undefined when calling createCompetitionEntry().');
                        }
                        if (requestParameters['competitionEntryCreateCommand'] == null) {
                            throw new runtime.RequiredError('competitionEntryCreateCommand', 'Required parameter "competitionEntryCreateCommand" was null or undefined when calling createCompetitionEntry().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/{competitionId}/entries".replace("{".concat("competitionId", "}"), encodeURIComponent(String(requestParameters['competitionId']))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CompetitionEntryCreateCommandToJSON)(requestParameters['competitionEntryCreateCommand']),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CompetitionEntryResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.createCompetitionEntry = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createCompetitionEntryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.dropCompetitionEntryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling dropCompetitionEntry().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/entry/{id}/drop".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CompetitionEntryResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.dropCompetitionEntry = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dropCompetitionEntryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.moveEntriesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['competitionId'] == null) {
                            throw new runtime.RequiredError('competitionId', 'Required parameter "competitionId" was null or undefined when calling moveEntries().');
                        }
                        if (requestParameters['competitionEntriesMoveCommand'] == null) {
                            throw new runtime.RequiredError('competitionEntriesMoveCommand', 'Required parameter "competitionEntriesMoveCommand" was null or undefined when calling moveEntries().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/{competitionId}/entries/move".replace("{".concat("competitionId", "}"), encodeURIComponent(String(requestParameters['competitionId']))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CompetitionEntriesMoveCommandToJSON)(requestParameters['competitionEntriesMoveCommand']),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CompetitionEntriesMoveResultFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.moveEntries = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.moveEntriesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.queryCompetitionEntriesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['competitionId'] == null) {
                            throw new runtime.RequiredError('competitionId', 'Required parameter "competitionId" was null or undefined when calling queryCompetitionEntries().');
                        }
                        queryParameters = {};
                        if (requestParameters['representing'] != null) {
                            queryParameters['representing'] = requestParameters['representing'];
                        }
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/{competitionId}/entries".replace("{".concat("competitionId", "}"), encodeURIComponent(String(requestParameters['competitionId']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentResourceWithLinksCompetitionEntryResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.queryCompetitionEntries = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryCompetitionEntriesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.readCompetitionEntryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling readCompetitionEntry().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/entry/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CompetitionEntryResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.readCompetitionEntry = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.readCompetitionEntryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.refreshCompetitionEntriesImageFallbackRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['competitionId'] == null) {
                            throw new runtime.RequiredError('competitionId', 'Required parameter "competitionId" was null or undefined when calling refreshCompetitionEntriesImageFallback().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/{competitionId}/entry/_refresh-image-fallback".replace("{".concat("competitionId", "}"), encodeURIComponent(String(requestParameters['competitionId']))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CountResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.refreshCompetitionEntriesImageFallback = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.refreshCompetitionEntriesImageFallbackRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.removeCompetitionEntryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling removeCompetitionEntry().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/entry/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.removeCompetitionEntry = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeCompetitionEntryRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.unDropCompetitionEntryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling unDropCompetitionEntry().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/entry/{id}/un-drop".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CompetitionEntryResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.unDropCompetitionEntry = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.unDropCompetitionEntryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.updateCompetitionEntryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling updateCompetitionEntry().');
                        }
                        if (requestParameters['competitionEntryUpdateCommand'] == null) {
                            throw new runtime.RequiredError('competitionEntryUpdateCommand', 'Required parameter "competitionEntryUpdateCommand" was null or undefined when calling updateCompetitionEntry().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/entry/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CompetitionEntryUpdateCommandToJSON)(requestParameters['competitionEntryUpdateCommand']),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CompetitionEntryResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.updateCompetitionEntry = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateCompetitionEntryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.updateCompetitionEntryLeaderRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling updateCompetitionEntryLeader().');
                        }
                        if (requestParameters['competitionEntryUpdateLeaderCommand'] == null) {
                            throw new runtime.RequiredError('competitionEntryUpdateLeaderCommand', 'Required parameter "competitionEntryUpdateLeaderCommand" was null or undefined when calling updateCompetitionEntryLeader().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/entry/{id}/leader".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CompetitionEntryUpdateLeaderCommandToJSON)(requestParameters['competitionEntryUpdateLeaderCommand']),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CompetitionEntryResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.updateCompetitionEntryLeader = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateCompetitionEntryLeaderRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.viewCompetitionEntriesIncludingIssuesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['competitionId'] == null) {
                            throw new runtime.RequiredError('competitionId', 'Required parameter "competitionId" was null or undefined when calling viewCompetitionEntriesIncludingIssues().');
                        }
                        queryParameters = {};
                        if (requestParameters['includeTeamSize'] != null) {
                            queryParameters['includeTeamSize'] = requestParameters['includeTeamSize'];
                        }
                        if (requestParameters['includeCheckIn'] != null) {
                            queryParameters['includeCheckIn'] = requestParameters['includeCheckIn'];
                        }
                        if (requestParameters['includePermit'] != null) {
                            queryParameters['includePermit'] = requestParameters['includePermit'];
                        }
                        if (requestParameters['includeFormResponse'] != null) {
                            queryParameters['includeFormResponse'] = requestParameters['includeFormResponse'];
                        }
                        if (requestParameters['includeDropped'] != null) {
                            queryParameters['includeDropped'] = requestParameters['includeDropped'];
                        }
                        if (requestParameters['includeRequireNetwork'] != null) {
                            queryParameters['includeRequireNetwork'] = requestParameters['includeRequireNetwork'];
                        }
                        if (requestParameters['onlyCheckIns'] != null) {
                            queryParameters['onlyCheckIns'] = requestParameters['onlyCheckIns'];
                        }
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/{competitionId}/entry/_view-including-issues".replace("{".concat("competitionId", "}"), encodeURIComponent(String(requestParameters['competitionId']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentResourceCompetitionEntryResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.viewCompetitionEntriesIncludingIssues = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.viewCompetitionEntriesIncludingIssuesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.viewCompetitionEntriesLookingForMoreRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['representing'] != null) {
                            queryParameters['representing'] = requestParameters['representing'];
                        }
                        if (requestParameters['organization'] != null) {
                            queryParameters['organization'] = requestParameters['organization'];
                        }
                        if (requestParameters['competitionGame'] != null) {
                            queryParameters['competitionGame'] = requestParameters['competitionGame'];
                        }
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        if (requestParameters['size'] != null) {
                            queryParameters['size'] = requestParameters['size'];
                        }
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/entry/_view/looking-for-more",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentResourceCompetitionEntryResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.viewCompetitionEntriesLookingForMore = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.viewCompetitionEntriesLookingForMoreRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.viewCompetitionEntryContactAccountsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling viewCompetitionEntryContactAccounts().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/entry/{id}/_view/contact-accounts".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentResourceContactAccountResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.viewCompetitionEntryContactAccounts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.viewCompetitionEntryContactAccountsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.viewCompetitionEntryMetaRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling viewCompetitionEntryMeta().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/entry/{id}/_view/meta".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CompetitionEntryMetaResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.viewCompetitionEntryMeta = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.viewCompetitionEntryMetaRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.viewCompetitionEntryParticipantContactAccountsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling viewCompetitionEntryParticipantContactAccounts().');
                        }
                        if (requestParameters['participantId'] == null) {
                            throw new runtime.RequiredError('participantId', 'Required parameter "participantId" was null or undefined when calling viewCompetitionEntryParticipantContactAccounts().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/entry/{id}/participant/{participantId}/_view/contact-accounts".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))).replace("{".concat("participantId", "}"), encodeURIComponent(String(requestParameters['participantId']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentResourceContactAccountResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.viewCompetitionEntryParticipantContactAccounts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.viewCompetitionEntryParticipantContactAccountsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.viewMyCompetitionEntriesIncludingIssuesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['competitionId'] == null) {
                            throw new runtime.RequiredError('competitionId', 'Required parameter "competitionId" was null or undefined when calling viewMyCompetitionEntriesIncludingIssues().');
                        }
                        queryParameters = {};
                        if (requestParameters['includeTeamSize'] != null) {
                            queryParameters['includeTeamSize'] = requestParameters['includeTeamSize'];
                        }
                        if (requestParameters['includeCheckIn'] != null) {
                            queryParameters['includeCheckIn'] = requestParameters['includeCheckIn'];
                        }
                        if (requestParameters['includePermit'] != null) {
                            queryParameters['includePermit'] = requestParameters['includePermit'];
                        }
                        if (requestParameters['includeFormResponse'] != null) {
                            queryParameters['includeFormResponse'] = requestParameters['includeFormResponse'];
                        }
                        if (requestParameters['includeDropped'] != null) {
                            queryParameters['includeDropped'] = requestParameters['includeDropped'];
                        }
                        if (requestParameters['includeRequireNetwork'] != null) {
                            queryParameters['includeRequireNetwork'] = requestParameters['includeRequireNetwork'];
                        }
                        if (requestParameters['onlyCheckIns'] != null) {
                            queryParameters['onlyCheckIns'] = requestParameters['onlyCheckIns'];
                        }
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/{competitionId}/entry/_view-my-including-issues".replace("{".concat("competitionId", "}"), encodeURIComponent(String(requestParameters['competitionId']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentResourceCompetitionEntryResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CompetitionEntryControllerApi.prototype.viewMyCompetitionEntriesIncludingIssues = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.viewMyCompetitionEntriesIncludingIssuesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return CompetitionEntryControllerApi;
}(runtime.BaseAPI));
exports.CompetitionEntryControllerApi = CompetitionEntryControllerApi;
